export function uniqueArrayOfObjects<T>(array: T[]): T[] {
  return [...new Set(array.map((s) => JSON.stringify(s)))].map((s) => JSON.parse(s))
}

export function uniqueArrayOfObjectById<T extends { id: string | number }>(array: T[]): T[] {
  return [...new Map(array.map((item) => [item['id'], item])).values()]
}
